import { Page, Text, View } from "@react-pdf/renderer";
import React from "react";
import { styles } from "../../style";

export const Page5 = () => {
  return (
    <Page size="A4" style={styles.page}>
      <View style={styles.spaceY}>
        <View style={styles.spaceX}>
          <Text>6.2.</Text>
          <Text style={styles.text}>
            Гэрээний аль нэг тал давагдашгүй хүчин зүйлийн улмаас гэрээгээр
            хүлээсэн үүргээ биелүүлэх боломжгүй болсон тохиолдолд гэрээний
            хариуцлагаас чөлөөлөгдөх үндэслэл болно.
          </Text>
        </View>
        <View style={styles.spaceX}>
          <Text>6.3.</Text>
          <Text style={styles.text}>
            Гэнэтийн болон давагдашгүй хүчин зүйлсийн улмаас аль нэг тал нь
            Гэрээгээр хүлээсэн үүргээ биелүүлэх боломжгүй болсон тохиолдолд энэ
            тухай нөгөө талдаа даруй мэдэгдэнэ.
          </Text>
        </View>
      </View>
      <View style={styles.header}>
        <Text
          style={[
            styles.title,
            styles.textBold,
            { letterSpacing: 0.2, marginTop: 16 },
          ]}
        >
          ДОЛОО.ХАРИУЦЛАГА
        </Text>
      </View>
      <View style={styles.spaceX}>
        <Text>7.1.</Text>
        <Text style={styles.text}>
          Энэхүү Гэрээний аль нэг тал нь Гэрээгээр хүлээсэн үүргээ биелүүлээгүйн
          улмаас нөгөө талдаа эдийн болон эдийн бус хохирол учруулсан бол
          тийнхүү учруулсан хохирлыг үл маргах журмаар нөхөн төлөх үүрэгтэй.
        </Text>
      </View>
      <View style={styles.spaceX}>
        <Text>7.2.</Text>
        <Text style={styles.text}>
          Талууд гэрээгээр хүлээсэн эрх, үүргээ нөгөө талын зөвшөөрөлгүйгээр
          гуравдагч этгээдэд шилжүүлэхгүй.
        </Text>
      </View>
      <View style={[styles.spaceX, { paddingTop: 4 }]}>
        <Text>7.3.</Text>
        <Text style={styles.text}>
          Энэхүү гэрээний 5.1-т заасан нөхцөлийг аль нэг тал зөрчсөн тохиолдолд
          тухайн тал нь нөгөө тал болон гуравдагч этгээдэд үүнтэй холбоотой
          учирсан хохирлыг нөхөн төлөх үүрэгтэй ба энэ нь холбогдох хуулиар
          хүлээлгэх бусад хариуцлагаас чөлөөлөгдөх үндэслэл болохгүй.
        </Text>
      </View>

      <View style={styles.header}>
        <Text
          style={[
            styles.title,
            styles.textBold,
            { letterSpacing: 0.2, marginTop: 16 },
          ]}
        >
          НАЙМ.ГЭРЭЭ ДУУСГАВАР БОЛОХ, ЦУЦЛАХ ҮНДЭСЛЭЛ
        </Text>
      </View>
      <View style={styles.spaceY}>
        <View style={styles.spaceX}>
          <Text>8.1.</Text>
          <Text style={styles.text}>
            Энэхүү Гэрээг Талууд харилцан тохиролцсоны үндсэн дээр цуцлах бөгөөд
            Талуудын аль нэг нь Гэрээг дангаар цуцлах эсвэл Гэрээнд нэмэлт,
            өөрчлөлт оруулахыг хүсвэл энэ тухайгаа хуанлийн 30 /гуч/ хоногийн
            өмнө нөгөө талд албан бичгээр мэдэгдэх үүрэгтэй.
          </Text>
        </View>

        <View style={styles.spaceX}>
          <Text>8.2.</Text>
          <Text style={styles.text}>
            Энэхүү гэрээ нь дор дурдсан үндэслэлээр дуусгавар болно.
          </Text>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>8.2.1. {""}</Text>
            <Text style={styles.subtext}>Гэрээний хугацаа дууссан;</Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text style={styles.subtext}>8.2.2. {""}</Text>
            <Text>
              Талууд харилцан тохиролцсоноор гэрээг хугацаанаас нь өмнө
              дуусгавар болгосон.
            </Text>
          </View>
        </View>
        <View style={styles.spaceX}>
          <Text>8.3.</Text>
          <Text style={styles.text}>
            Талууд дараах тохиолдолд Гэрээг аль нэг талын санаачилгаар цуцална.
          </Text>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>8.3.1. {""}</Text>
            <Text style={styles.subtext}>
              Талуудын аль нэг нь Гэрээгээр хүлээсэн үүргээ зохих ёсоор
              биелүүлээгүй;
            </Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text style={styles.subtext}>8.3.2. {""}</Text>
            <Text>Хуульд заасан бусад үндэслэл.</Text>
          </View>
        </View>
      </View>
      <View style={styles.header}>
        <Text
          style={[
            styles.title,
            styles.textBold,
            { letterSpacing: 0.2, marginTop: 16 },
          ]}
        >
          ЕС.МАРГААН ШИЙДВЭРЛЭХ
        </Text>
      </View>
      <View style={styles.spaceY}>
        <View style={styles.spaceX}>
          <Text>9.1.</Text>
          <Text style={styles.text}>
            Энэхүү Гэрээтэй холбоотой аливаа маргааныг Талууд эв зүйгээр
            шийдвэрлэх ба Талууд гурваас доошгүй удаагийн албан уулзалт зохион
            байгуулж, маргаан бүхий асуудлыг харилцан зөвшилцөнө.
          </Text>
        </View>
        <View style={styles.spaceX}>
          <Text>9.2.</Text>
          <Text style={styles.text}>
            Хэрэв албан уулзалтууд амжилтгүй болж Талууд харилцан тохиролцоонд
            хүрээгүй тохиолдолд Талуудын аль нэг нь Монгол улсын шүүхэд хандаж
            шийдвэрлүүлнэ.
          </Text>
        </View>
        <View style={styles.spaceX}>
          <Text>9.3.</Text>
          <Text style={styles.text}>
            Энэхүү Гэрээтэй холбоотой асуудлыг Монгол Улсын хууль тогтоомжийн
            дагуу тайлбарлана.
          </Text>
        </View>
      </View>
    </Page>
  );
};

export default Page5;
